export const ExperienceLevelSelector = ({ 
  selectedLevel, 
  onLevelChange, 
  userSeniorityLevel 
}) => {
  const experienceLevels = [
    {
      value: 'entry',
      label: 'Entry Level',
      description: '0-2 years experience',
      seniorityMatch: ['entry', 'junior']
    },
    {
      value: 'median',
      label: 'Mid Level',
      description: '3-7 years experience',
      seniorityMatch: ['mid']
    },
    {
      value: 'experienced',
      label: 'Senior Level',
      description: '8+ years experience',
      seniorityMatch: ['senior', 'executive']
    }
  ];

  return (
    <div className="bg-white rounded-lg shadow p-6">
      <h3 className="text-lg font-semibold text-gray-900 mb-4">Experience Level</h3>
      <div className="space-y-3">
        {experienceLevels?.map((level) => {
          const isRecommended = level?.seniorityMatch?.includes(userSeniorityLevel);
          
          return (
            <label
              key={level?.value}
              className={`relative flex cursor-pointer rounded-lg p-4 focus:outline-none ${
                selectedLevel === level?.value
                  ? 'bg-primary/5 border-2 border-primary' :'bg-white border-2 border-gray-200 hover:border-gray-300'
              }`}
            >
              <input
                type="radio"
                value={level?.value}
                checked={selectedLevel === level?.value}
                onChange={(e) => onLevelChange(e?.target?.value)}
                className="sr-only"
              />
              <div className="flex flex-1">
                <div className="flex-1">
                  <div className="flex items-center">
                    <span className={`block text-sm font-medium ${
                      selectedLevel === level?.value ? 'text-primary/90' : 'text-gray-900'
                    }`}>
                      {level?.label}
                    </span>
                    {isRecommended && (
                      <span className="ml-2 inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-green-100 text-green-800">
                        Recommended
                      </span>
                    )}
                  </div>
                  <span className={`block text-sm ${
                    selectedLevel === level?.value ? 'text-primary/80' : 'text-gray-500'
                  }`}>
                    {level?.description}
                  </span>
                </div>
              </div>
              {/* Selection indicator */}
              <div className="flex-shrink-0 flex items-center">
                <div className={`w-4 h-4 rounded-full border-2 flex items-center justify-center ${
                  selectedLevel === level?.value
                    ? 'border-primary bg-primary' :'border-gray-300'
                }`}>
                  {selectedLevel === level?.value && (
                    <div className="w-2 h-2 rounded-full bg-white"></div>
                  )}
                </div>
              </div>
            </label>
          );
        })}
      </div>
      {/* Help Text */}
      <div className="mt-4 p-3 bg-gray-50 rounded-md">
        <p className="text-sm text-gray-600">
          {userSeniorityLevel && (
            <>Based on your profile ({userSeniorityLevel} level), we've recommended the most relevant experience level. </>
          )}
          You can adjust this to see salary data for different experience levels.
        </p>
      </div>
    </div>
  );
};